import * as React from "react";
import * as ToggleGroupPrimitive from "@radix-ui/react-toggle-group";
import { cn } from "@/lib/utils";

/** TB brand Segmented Control — exclusive choice between 2-5 options (text OR icon). */
/** Props for the individual toggle item (Segmented is always exclusive choice). */
export type SegmentedProps = Omit<
  Extract<React.ComponentPropsWithoutRef<typeof ToggleGroupPrimitive.Root>, { type: "single" }>,
  "type"
>;

export const Segmented = React.forwardRef<
  React.ElementRef<typeof ToggleGroupPrimitive.Root>,
  SegmentedProps
>(({ className, ...props }, ref) => (
  <ToggleGroupPrimitive.Root
    ref={ref}
    type="single"
    className={cn(
      "inline-flex gap-0.5 rounded-[var(--tb-radius-sm)] bg-tb-porcelain p-[3px]",
      className,
    )}
    {...props}
  />
));
Segmented.displayName = "Segmented";

export const SegmentedItem = React.forwardRef<
  React.ElementRef<typeof ToggleGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof ToggleGroupPrimitive.Item>
>(({ className, ...props }, ref) => (
  <ToggleGroupPrimitive.Item
    ref={ref}
    className={cn(
      "inline-flex min-h-[38px] cursor-pointer items-center justify-center gap-[7px] whitespace-nowrap rounded-[calc(var(--tb-radius-sm)-3px)] px-[18px] text-[12px] font-medium text-[var(--fg-muted)] transition-colors duration-[var(--tb-duration-2)] ease-[var(--tb-ease-linen)]",
      "hover:text-[var(--fg)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-tb-green focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
      "data-[state=on]:bg-tb-white data-[state=on]:text-[var(--fg)] data-[state=on]:shadow-[0_1px_3px_rgb(61_63_57/0.12)]",
      "[&_svg]:h-[15px] [&_svg]:w-[15px]",
      className,
    )}
    {...props}
  />
));
SegmentedItem.displayName = "SegmentedItem";
